import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
export function Navigation({
  isScrolled
}: {
  isScrolled?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    to: '/',
    label: 'Home'
  }, {
    to: '/about',
    label: 'About Us'
  }, {
    to: '/process',
    label: 'Our Services'
  }, {
    to: '/showroom',
    label: 'Our Gallery'
  }, {
    to: '/contact',
    label: 'Contact Us'
  }];
  return <nav className={`relative w-full z-50 transition-all duration-300 px-6 border-b ${isScrolled ? 'bg-white shadow-lg border-charcoal/5' : 'bg-white border-charcoal/5'}`} data-id="element-85">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-86">
        <Link to="/" className="flex items-center group" onClick={() => setIsOpen(false)} data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/cftwjMdZDCJ9X67HQPACwV/ChatGPT_Image_May_21,_2026,_07_24_32_PM.png" alt="NK Home Improvement Logo" className="h-20 md:h-28 w-auto object-contain transition-transform duration-300 group-hover:scale-105" data-id="element-88" />
        </Link>

        {/* Desktop Navigation - Aligned Right */}
        <div className={`hidden lg:flex items-center gap-10 text-[13px] font-black uppercase tracking-[0.2em] transition-colors duration-300 text-charcoal`} data-id="element-89">
        
          {navLinks.map(link => <Link key={link.to} to={link.to} className={`hover:text-[#6B0D24] transition-colors ${location.pathname === link.to ? 'text-[#6B0D24]' : ''}`} data-id="element-90">
              {link.label}
            </Link>)}
        </div>

        {/* Mobile Menu Button */}
        <button className={`md:hidden p-2 transition-colors text-charcoal`} onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-91">
          {isOpen ? <X size={32} data-id="element-92" /> : <Menu size={32} data-id="element-93" />}
        </button>
      </div>

      {/* Mobile Navigation Overlay */}
      <AnimatePresence data-id="element-94">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="absolute top-full left-0 w-full bg-white border-b-3 border-charcoal shadow-xl lg:hidden overflow-y-auto max-h-[80vh]" data-id="element-95">
            <div className="flex flex-col p-8 gap-6" data-id="element-96">
              {navLinks.map(link => <Link key={link.to} to={link.to} className={`text-base font-black uppercase tracking-widest ${location.pathname === link.to ? 'text-[#6B0D24]' : 'text-charcoal'} hover:text-[#6B0D24] transition-colors`} onClick={() => setIsOpen(false)} data-id="element-97">
                  {link.label}
                </Link>)}
              <Link to="/contact" className="bg-[#6B0D24] text-white py-5 text-center font-black uppercase tracking-widest text-xs hover:bg-[#5A0B1E] transition-colors mt-4" onClick={() => setIsOpen(false)} data-id="element-98">
                Request a Quote
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}